import { Params } from 'types/api';

const generateParams = (rawParams: Partial<Params>): string => {
  const params = new URLSearchParams();

  Object.entries(rawParams).forEach(([key, value]) => {
    if (Array.isArray(value) && value.length > 0) {
      params.append(key, value.join(','));
    } else if (value !== undefined && value !== null) {
      params.append(key, value.toString());
    }
  });

  return params.toString() ? `?${params.toString()}` : '';
};

export default generateParams;
